import React, { useState } from 'react';
import { BEM } from '@feedfm/feed-util';
import AsyncSelect from 'react-select/async';
import userSelectQuery from './UserSelectQuery.gql';
import { useLazyQuery } from '@apollo/client';

import './UserSelect.scss';
import {
  UserSelectQuery,
  UserSelectQuery_users_results_user,
  UserSelectQueryVariables,
} from '~/graphqlTypes/UserSelectQuery';
import { useDebouncedCallback } from 'use-debounce';

const bem = new BEM( 'ops-user-select', [] );

function printLabel( user: UserSelectQuery_users_results_user ): string {
  return `${user.emailAddress}`;
}

interface SelectOption {
  label: string;
  value: UserSelectQuery_users_results_user;
}

export interface UserSelectProps {
  className?: string;
  onChange: ( userEmail: UserSelectQuery_users_results_user ) => void;
}

export const UserSelect = ( { className, onChange }: UserSelectProps ) => {
  const [searchUsers] = useLazyQuery<UserSelectQuery, UserSelectQueryVariables>( userSelectQuery );
  const [selectedUser, setSelectedUser] = useState<UserSelectQuery_users_results_user>();

  const debouncedLoadOptions = useDebouncedCallback( async ( searchTerm, callback ) => {
    const { data } = await searchUsers( { variables: { searchTerm, max: 15 } } );
    let tagOptions: SelectOption[] = [];
    const results = data?.users?.results;
    if ( results ) {
      tagOptions = results.map( ( { user } ) => ( { label: printLabel( user ), value: user } ) );
    }
    callback( tagOptions );
  }, 750 );

  const loadOptions = ( searchTerm: string, callback: ( options: SelectOption[] ) => void ) => {
    debouncedLoadOptions( searchTerm, callback );
  };

  return (
    <AsyncSelect<SelectOption>
      data-testid="ops-role-select"
      className={ BEM.$( bem, className ) }
      placeholder="Type user's name or email to search..."
      onChange={ ( option ) => {
        if ( option?.value ) {
          setSelectedUser( option.value );
          onChange( option.value );
        }
      } }
      loadOptions={ loadOptions }
      components={ { DropdownIndicator: null } }
      value={ selectedUser && { label: printLabel( selectedUser ), value: selectedUser } }
    />
  );
};

UserSelect.displayName = 'UserSelect';
